export default "__VITE_ASSET__BWOacESz__"